export enum MaterialValuesEnum {
  Canvas = 'canvas', // Płótno
  Paper = 'paper', // Papier
  Cardboard = 'cardboard', // Tektura
  Metal = 'metal', // Metal
  Wood = 'wood', // Drewno
  Textile = 'textile', // Tkanina
  EpoxyResin = 'epoxyResin', // Żywica epoksydowa
  NobleMetal = 'nobleMetal', // Metal szlachetny
  Shlagmetal = 'shlagmetal', // Szlagmetal
  Plastic = 'plastic', // Tworzywo sztuczne
  Glass = 'glass', // Szkło
  MixedMedia = 'mixedMedia', // Mixed media
  Bronze = 'bronze', // Brąz
  PatinatedBronze = 'patinatedBronze', // Brąz patynowany
  Fireclay = 'fireclay', // Szamot
  Porcelain = 'porcelain', // Porcelana
  Clay = 'clay', // Glina
  Faience = 'faience', // Fajans
  Stone = 'stone', // Kamień
  Marble = 'marble', // Marmur
  Granite = 'granite', // Granit
  Crayon = 'crayon', // Kredka
  Charcoal = 'charcoal', // Węgiel
  Pencil = 'pencil', // Ołówek
  Marker = 'marker', // Flamaster
  Other = 'other' // Inny
}
